import { isEmpty, set } from 'lodash'
import { largeSizes, legendDefault } from '.'
import { defaultExportMenu, getColumnSeries } from '../helpers'

export default ({ config, data, color, size = 'sm', legendLabels = {} }) => {
  const { labelColor } = color
  const { series, ...restConfig } = config
  const {
    title,
    xTitle,
    xKey,
    scrollbar,
    disabledLegend = false,
    removeLegend,
    labelsRotation,
    exportingMenu,
    disabledAnimations = false
  } = restConfig

  const keys = []

  if (!isEmpty(series)) {
    series.forEach((el) => {
      // get custom legend labels with translated values
      !isEmpty(legendLabels) &&
        Object.keys(legendLabels).forEach((key) => {
          if (el.includes(key)) {
            keys.push(legendLabels[key])
          }
        })
    })
  }

  const configuration = {
    data: data,
    type: 'XYChart',
    series: [
      getColumnSeries({
        series,
        otherConfig: {
          color,
          disabledAnimations,
          legendLabel: keys,
          ...restConfig
        }
      })
    ],
    cursor: {},
    scrollbarX: {
      disabled: !scrollbar,
      parent: 'bottomAxesContainer'
    },
    xAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: xKey
        },
        title: {
          text: xTitle || null,
          fill: labelColor,
          fontSize: !largeSizes.includes(size) && 12
        },
        rangeChangeDuration: 500,
        renderer: {
          labels: {
            rotation: labelsRotation || 0,
            fontSize: !largeSizes.includes(size) && 10,
            fill: labelColor
          },
          grid: {
            template: {
              strokeWidth: 0,
              fill: labelColor
            }
          },
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.7,
          maxLabelPosition: 0.98
        }
      }
    ],
    yAxes: [
      {
        title: {
          text: title || null,
          fill: labelColor,
          fontSize: !largeSizes.includes(size) && 12
        },
        id: 'CommonYAxis',
        type: 'ValueAxis',
        renderer: {
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          labels: {
            fill: labelColor,
            fontSize: 10
          }
        }
      },
      {
        type: 'ValueAxis',
        renderer: {
          opposite: true,
          line: {
            strokeOpacity: 0,
            fill: labelColor
          },
          labels: {
            fill: labelColor,
            fontSize: !largeSizes.includes(size) && 10
          }
        }
      }
    ],
    legend: legendDefault(labelColor, disabledLegend)
  }

  // To be kept for compatibility with previous versions
  if (removeLegend) {
    delete configuration.legend
  }

  if (labelsRotation && labelsRotation !== 0) {
    set(configuration.xAxes[0], 'renderer.labels.horizontalAlignment', 'middle')
  } else {
    set(configuration.xAxes[0], 'renderer.labels.horizontalCenter', 'right')
    set(configuration.xAxes[0], 'renderer.labels.verticalCenter', 'left')
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      configuration.exporting = defaultExportMenu
    } else {
      configuration.exporting = exportingMenu.config
    }
  }
  return configuration
}
